module.exports = __webpack_public_path__ + "img/Title-other.aff56c86.png";